import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoriemenuComponent } from './categoriemenu.component';
import { PopupcategoriemenuComponent } from './popupcategoriemenu/popupcategoriemenu.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/@fury/shared/material-components.module';
import { BreadcrumbsModule } from 'src/@fury/shared/breadcrumbs/breadcrumbs.module';
import { MatInputModule } from '@angular/material';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FuryCardModule } from 'src/@fury/shared/card/card.module';

@NgModule({
  declarations: [CategoriemenuComponent, PopupcategoriemenuComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    BreadcrumbsModule,
    MatInputModule,
    NgxDatatableModule,
    FuryCardModule
  ],
  entryComponents: [PopupcategoriemenuComponent]

})
export class CategoriemenuModule { }
